import checkdigit from 'checkdigit';
import IBAN from 'iban';
import React, { useState, useCallback } from 'react';

import { IconButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { Input } from '@eika/input';

import { Config } from '../config';

const FindIBAN: React.FC<Config> = ({ texts }) => {
    const [state, setState] = useState<{ error: string; value: string; valid: boolean; iban: string }>({
        error: '',
        value: '',
        valid: false,
        iban: '',
    });

    const checkAccountNumber = useCallback(
        (accountNumber: string) => {
            try {
                const generatedIban = IBAN.fromBBAN('NO', accountNumber);
                const isValid = checkdigit.mod11.isValid(accountNumber);

                if (!isValid) {
                    setState((prevState) => ({
                        ...prevState,
                        error: texts.errorInvalidAccount,
                        valid: false,
                        iban: '',
                    }));
                } else {
                    setState((prevState) => ({
                        ...prevState,
                        error: '',
                        valid: true,
                        iban: generatedIban,
                    }));
                }
            } catch {
                setState((prevState) => ({
                    ...prevState,
                    error: texts.errorInvalidAccount,
                    valid: false,
                    iban: '',
                }));
            }
        },
        [texts],
    );

    const handleChange = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>): void => {
            const userInput = event.target.value;
            setState((prevState) => ({
                ...prevState,
                value: userInput,
            }));

            if (userInput.length < 11) {
                setState((prevState) => ({
                    ...prevState,
                    error: texts.errorAccountLength,
                    valid: false,
                    iban: '',
                }));
            } else {
                checkAccountNumber(userInput);
            }
        },
        [checkAccountNumber, texts],
    );

    const handleCopy = useCallback(() => {
        navigator.clipboard.writeText(state.iban);
    }, [state.iban]);

    return (
        <div className="esc-ibangenerator__input">
            <Input value={state.value} onChange={handleChange} error={state.error} label={texts.inputLabelAccount} />
            {state.valid && (
                <p className="typography-subtitle esc-ibangenerator__valid">
                    {texts.successMessageIban} <strong>{state.iban}</strong>
                    <IconButton screenReaderText={texts.copyButtonText} icon={IconTypes.COPY_24} onClick={handleCopy} />
                </p>
            )}
        </div>
    );
};

export default FindIBAN;
